// SignupPage.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';

const SignupPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    city: '',
    interests: '',
    password: '',
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!termsAccepted) {
      setError("Please accept the terms and privacy policy.");
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/api/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        login(data.user);
        navigate('/');
      } else {
        const errData = await response.json();
        setError(errData.detail || "Signup failed.");
      }
    } catch (err) {
      setError("Signup failed. Please try again.");
    }
  };

  const handleGoogleSignup = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/google-auth`);
      if (!response.ok) {
        console.error('Error response:', response.statusText);
        return;
      }
      const data = await response.json();
      window.location.href = data.url;
    } catch (error) {
      console.error('Error fetching Google auth URL:', error);
    }
  };

  return (
    <div className="auth-container">
      <h2>Sign Up</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSignup}>
        <input 
          type="text" 
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          required 
        />
        <input 
          type="email" 
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required 
        />
        <input 
          type="text" 
          name="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          required 
        />
        <input 
          type="text" 
          name="city"
          placeholder="City"
          value={formData.city}
          onChange={handleChange}
          required 
        />
        <textarea 
          name="interests"
          placeholder="Interests (comma separated)"
          value={formData.interests}
          onChange={handleChange}
        />
        <input 
          type="password" 
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required 
        />
        <label>
          <input 
            type="checkbox" 
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
          I accept the Terms of Use and Privacy Policy.
        </label>
        <button type="submit">Sign Up</button>
      </form>
      <button onClick={handleGoogleSignup}>Sign Up with Google</button>
      <p>Already have an account? <a href="/login">Login</a></p>
    </div>
  );
};

export default SignupPage;
